import { featureAbbr } from "../../configs/constants";
const messages = {
  [`${featureAbbr}.count`]: "بعضی از آیتم های فاکتور موجود نیستند",

  "auth.user.new": "افزودن کاربر جدید",
  "auth.section.new": "افزودن بخش جدید",
  "auth.access.manage": "مدیریت دسترسی ها",

  "user.info.UserName": "نام کاربری",
  "user.info.UserRoleId": "نوع کاربر",
  "user.info.Password": "رمز عبور",
  "user.info.IsActive": "فعال",
  "user.info.Mobile": "شماره همراه",

  "user.info.cancel": "انصراف",
  "user.info.save": "ثبت کاربر",

  "role.info.title": "نام گروه",
  "role.info.save": "ثبت گروه",
  "role.info.isActive": "فعال",

  "permission.form.save": "ثبت دسترسی فرم",
  "permission.element.save": "ثبت دسترسی اجزای فرم",
  "permission.user.remove":"حذف دسترسی اختصاصی کاربر",

};

export default messages;
